export const GET_PREGUNTA = 'GET_PREGUNTA';
export const LOADING_PREGUNTA = 'LOADING_PREGUNTA';
export const SAVE_LOADER_PREGUNTA = 'SAVE_LOADER_PREGUNTA'